import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { provideRouter } from '@angular/router'
import { AuthConfig, HttpsValidationType, provideElderAuthDynamic } from '@elderbyte/ngx-auth'
import {
  KafentConfig,
  KafentEventTransport,
  provideElderBrandAssets,
  provideElderDefaults,
  provideElderHttpClient,
  provideElderLanguage,
  provideElderLocaleDeCh,
  provideElderThemeInit,
  provideElderTimeDefaults,
  provideElderTranslate,
  provideKafentDynamic,
} from '@elderbyte/ngx-starter'
import { environment, isKafentEnabled, isSecurityMockEnabled } from '../environments/environment'
import { appRoutes } from './app-routing.module'

const createKafentConfig = (): KafentConfig => ({
  kafentUrl: environment.kafent + '/api/events',
  transport: isKafentEnabled() ? KafentEventTransport.SSE : KafentEventTransport.DISABLED,
})

// Because of AOT Compiler
const createAuthConfig = (): AuthConfig => {
  console.info('createAuthConfig with env:', environment)

  return {
    issuerUrl: environment.issuerUrl,
    validation: { httpsRequired: HttpsValidationType.None },
    clientId: environment.clientId,
    roleHierarchy: environment.roleHierarchy,
    scope: environment.scope,
    accessDeniedRoute: 'app/accessdenied',
    mock: {
      enable: isSecurityMockEnabled(),
      user: {
        roles: ['OWNER'],
      },
    },
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(appRoutes),
    provideElderHttpClient(),
    provideElderDefaults(),
    provideElderLanguage({ langs: ['de', 'en'], defaultLang: 'de' }),
    provideElderTranslate(),
    provideElderBrandAssets(),
    provideElderLocaleDeCh(), // TODO: Can be removed, since is library default
    provideElderTimeDefaults(), // TODO: Can be removed, since is library default
    provideElderAuthDynamic({
      provide: AuthConfig,
      useFactory: createAuthConfig,
    }),
    provideKafentDynamic({
      provide: KafentConfig,
      useFactory: createKafentConfig,
    }),
    provideElderThemeInit(),
  ],
}
